import { AppBar, Toolbar, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import logo from '../../../assets/images/LogoTech.svg';
import WifiOffIcon from '@material-ui/icons/WifiOff';
import WifiIcon from '@material-ui/icons/Wifi';

const useStyles = makeStyles(() => ({
    root: {
        boxShadow: 'none'
    },
    status: {
        marginLeft: 'auto',
        marginRight: '10px'
    }
}));

export function Topbar({ isOnline }) {
    const classes = useStyles();

    return (
        <AppBar className={classes.root} color="secondary">
            <Toolbar>
                <img height="48px" width="120px" alt="Logo" src={logo} />
                <Tooltip title="You are offline">{isOnline ? <WifiIcon /> : <WifiOffIcon />}</Tooltip>
            </Toolbar>
        </AppBar>
    );
}